export default "__VITE_ASSET__Td38m7ER__"